import React, { useState, useContext } from 'react'
import Textarea from 'components/Textarea'
import { FormattedMessage } from 'react-intl'
import Button from 'components/Button'
import BoldComment from 'assets/icons/bold-comment'
import HighlightComment from 'assets/icons/highlight-comment'
import AssigmentComment from 'assets/icons/assigment-comment'
import LeaveComment from 'assets/icons/leave-comment'
import { updateReplyById } from 'api/site'
import { SiteContext } from 'providers/site'
import { useParams } from 'react-router-dom'

import {
  CommentArea,
  CommentButtonsLeft,
  CommentButtonsRight,
  LeaveCommentBg,
  TextAreaControls
} from './style'
import { SITE_STATUS_EDIT_ONLY_ID, SITE_STATUS_SUBMITTED_EDIT_ONLY_ID } from 'constants/siteStatuses'
import { editOnly } from 'routing/constants'

const UpdateFormReply = ({ commentId, text, setEditComment, getReplyData }) => {
  const params = useParams()
  const { site } = useContext(SiteContext)
  const [commentsTextArea, setCommentsTextArea] = useState(text)
  const [height, setHeight] = useState('186px')
  const [isExpanded, setIsExpanded] = useState(true)

  const editOnlySite = site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID ? editOnly : null;

  const onCommentsChange = (e) => {
    setCommentsTextArea(e.target.value)
  }

  const handleExpandChange = () => {
    setIsExpanded(true)
    setHeight('186px')
  }

  const handleCancelExpandChange = () => {
    setCommentsTextArea('')
    setIsExpanded(false)
    setHeight('25px')
    setEditComment(false)
  }

  const updateReply = async () => {
    const updateData = {
      content: commentsTextArea
    };

    try {
      await updateReplyById(site.id, commentId, params.siteHistoryId, updateData, editOnlySite);
      await getReplyData();
      setCommentsTextArea('');
      setEditComment(false);
    } catch (error) {
      throw error;
    }
  };

  return (
    <div>
      <CommentArea>
        <Textarea
          value={commentsTextArea}
          field='commentsTextArea'
          onChange={onCommentsChange}
          onClick={handleExpandChange}
          placeholder="commentsPlaceholder"
          height={height}
          dataTest='comments-text-area'
          resize="none"
          border="none"
          boxShadow="none"
          marginBottom={isExpanded ? "" : "0"}
        />
        {isExpanded && <TextAreaControls>
          <CommentButtonsLeft>
            <Button marginTop="0" type="leftCommentButtons" onClick={() => {}}>
              <BoldComment />
            </Button>
            <Button marginTop="0" type="leftCommentButtons" onClick={() => {}}>
              <HighlightComment />
            </Button>
            <Button marginTop="0" type="leftCommentButtons" onClick={() => {}}>
              <AssigmentComment />
            </Button>
          </CommentButtonsLeft>
          <CommentButtonsRight>
            <Button marginTop="0" type="cancelComments" onClick={handleCancelExpandChange}>
              <FormattedMessage id="cancel" />
            </Button>
            <div data-testid="update-reply-btn" style={{ alignSelf: 'center' }} onClick={updateReply}>
              <LeaveCommentBg>
                <LeaveComment />
              </LeaveCommentBg>
            </div>
          </CommentButtonsRight>
        </TextAreaControls>}
      </CommentArea>
    </div>
  )
}

export default UpdateFormReply
